class LenisScroll {
  constructor() {
    this.lenis = null;
    this.frameId = null;
    this.init();
  }

  init() {
    if (typeof Lenis === 'undefined') {
      console.warn('Lenis not loaded yet, retrying in 100ms');
      setTimeout(() => this.init(), 100);
      return;
    }

    this.lenis = new Lenis({
      duration: 1.2,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      orientation: 'vertical',
      gestureOrientation: 'vertical',
      smoothWheel: true,
      wheelMultiplier: 1,
      syncTouch: false,
      touchMultiplier: 1.5,
      infinite: false,
    });

    this.gsapTick = null;

    const ownRaf = (time) => {
      this.lenis.raf(time);
      this.frameId = requestAnimationFrame(ownRaf);
    };

    const useGsapTicker = () => {
      if (this.gsapTick || typeof gsap === 'undefined') return false;

      this.gsapTick = (time) => {
        this.lenis.raf(time * 1000);
      };
      gsap.ticker.add(this.gsapTick);
      gsap.ticker.lagSmoothing(0);

      if (this.frameId) {
        cancelAnimationFrame(this.frameId);
        this.frameId = null;
      }
      return true;
    };

    if (!useGsapTicker()) {
      this.frameId = requestAnimationFrame(ownRaf);
      let waits = 0;
      const waitForGsap = () => {
        if (useGsapTicker() || waits++ > 300) return;
        requestAnimationFrame(waitForGsap);
      };
      requestAnimationFrame(waitForGsap);
    }

    this.lenis.on('scroll', () => {
      if (window.ScrollTrigger) window.ScrollTrigger.update();
    });

    if (window.ScrollTrigger && window.ScrollTrigger.config) {
      window.ScrollTrigger.config({ ignoreMobileResize: true });
    }

    var lastHeight = -1;
    var syncTimer = 0;

    var runSync = () => {
      syncTimer = 0;

      var h = document.documentElement.scrollHeight;
      if (h === lastHeight) return;

      if (this.lenis && this.lenis.isScrolling) {
        sync(300);
        return;
      }

      this.lenis.resize();
      if (window.ScrollTrigger) window.ScrollTrigger.refresh();
      if (window.LuxeScroll) window.LuxeScroll.invalidate();

      lastHeight = document.documentElement.scrollHeight;
    };

    var sync = (delay) => {
      if (syncTimer) clearTimeout(syncTimer);
      syncTimer = setTimeout(runSync, delay === undefined ? 150 : delay);
    };

    window.addEventListener('load', () => {
      sync(0);
      setTimeout(() => sync(0), 600);
    });

    var onIntro = () => {
      sync(0);
      setTimeout(() => sync(0), 300);
      setTimeout(() => sync(0), 800);
    };
    if (window.__czardIntro) onIntro();
    else document.addEventListener('czard:intro', onIntro, { once: true });

    if ('ResizeObserver' in window) {
      var ro = new ResizeObserver(() => sync());
      ro.observe(document.body);
    }
    window.addEventListener('load', () => {
      var imgs = document.images;
      var onImg = () => sync();
      for (var i = 0; i < imgs.length; i++) {
        if (!imgs[i].complete) imgs[i].addEventListener('load', onImg, { once: true });
      }
    });
  }

  destroy() {
    if (this.gsapTick && typeof gsap !== 'undefined') {
      gsap.ticker.remove(this.gsapTick);
    }
    if (this.lenis) {
      this.lenis.destroy();
    }
    if (this.frameId) {
      cancelAnimationFrame(this.frameId);
    }
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    window.lenisScroll = new LenisScroll();
  });
} else {
  window.lenisScroll = new LenisScroll();
}
